module.exports = __webpack_public_path__ + "static/media/img_flipCards-04.630c4627.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/home/images/flipbox/img_flipCards-04.png
// module id = 439
// module chunks = 4